module.exports = __webpack_public_path__ + "assets/img/49a.c499e91d.jpg";